import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { TEL_URL, PHONE } from "@/lib/api";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  const links = [
    { to: "/", label: "Home" },
    { to: "/packages", label: "Tour Packages" },
    { to: "/#booking", label: "Book Now" },
  ];

  return (
    <nav
      data-testid="main-nav"
      className="fixed top-0 left-0 right-0 z-50 bg-[#0A0E17]/75 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-2 group">
          <span className="font-serif text-2xl md:text-3xl text-white tracking-tight">
            Amyee
          </span>
          <span className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mt-1">
            Travels
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
              className={`text-sm uppercase tracking-widest transition-colors ${
                loc.pathname === l.to ? "text-white" : "text-gray-400 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <a
          href={TEL_URL}
          data-testid="nav-call-button"
          className="hidden md:flex items-center gap-2 bg-[#D95D39] hover:bg-[#E27D60] text-white px-5 py-3 transition-colors"
        >
          <Phone className="w-4 h-4" />
          <span className="text-sm tracking-wider">{PHONE}</span>
        </a>

        <button
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A0E17]/95 border-t border-white/10 px-6 py-6 space-y-4">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-link-${l.label.replace(/\s+/g, "-").toLowerCase()}`}
              className="block text-white text-lg font-serif"
            >
              {l.label}
            </Link>
          ))}
          <a
            href={TEL_URL}
            data-testid="mobile-call-button"
            className="flex items-center gap-2 bg-[#D95D39] text-white px-5 py-3 mt-4 w-fit"
          >
            <Phone className="w-4 h-4" /> {PHONE}
          </a>
        </div>
      )}
    </nav>
  );
};
